var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10,10-4.5,10-10S15.5,0,10,0ZM15.2,8.8l-3.7,3.6c-.7.6-1.5,1-2.3,1s-1.7-.3-2.3-.9l-1.6-1.6c-.3-.3-.3-.8,0-1.2.3-.3.9-.3,1.2,0l1.6,1.6c.6.6,1.7.6,2.3,0l3.7-3.6c.3-.3.9-.3,1.2,0,.3.3.3.9,0,1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkRounded);
export default __webpack_public_path__ + "static/media/checkmark-rounded.e4f4494fe6a94ca3c37b9029438f19bf.svg";
export { ForwardRef as ReactComponent };